/**
 * JSON-LD + FAQ copy for /about.
 *
 * Lives outside the page component so `src/routes/_app/about.tsx` can build
 * head metadata without pulling About.tsx (videos, portraits, EnquiryForm)
 * into the critical route-tree bundle.
 */
export const ABOUT_BREADCRUMB_LD = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://lohalink.in/" },
    { "@type": "ListItem", "position": 2, "name": "About", "item": "https://lohalink.in/about" }
  ]
};

export const ABOUT_FAQS: { q: string; a: string }[] = [
  {
    q: "How does escrow for metal trade in India work on LohaLink?",
    a: "Every trade on LohaLink is settled through an RBI-compliant nodal escrow account. The buyer's funds are locked in escrow before the seller dispatches the consignment, and released to the seller only after the buyer confirms receipt and quality at the weighbridge. This eliminates bad debt risk in the scrap business and removes the need for post-dated cheques (PDCs) or letters of credit.",
  },
  {
    q: "How are GSTIN and KYC of buyers and sellers auto-verified?",
    a: "LohaLink uses live GSTIN auto-verification APIs to validate every buyer and seller against the GSTN database in real time — checking legal name, registration status, principal place of business and filing history. PAN, bank account and beneficiary name are matched via penny-drop bank verification, so only GST verified scrap dealers and verified sponge iron suppliers are allowed to transact.",
  },
  {
    q: "How are weighbridge disputes resolved in scrap trading?",
    a: "Weighbridge disputes are handled through tamper-evident dharam kanta receipts, geotagged loading photos and AI scrap metal grading. If the buyer's inbound weighbridge differs from the seller's outbound by more than the agreed tolerance, LohaLink's dispute resolution team reviews the digital trail, mediates a fair settlement, and adjusts the escrow release accordingly — usually within 24–48 hours.",
  },
  {
    q: "What makes secure payment scrap trading on LohaLink different?",
    a: "Funds never touch LohaLink's books — they sit in a regulated nodal escrow at a partner bank. Combined with GST-verified counterparties, AI quality grading from yard photos, and a documented audit trail for every truck, secure payment scrap trading on LohaLink delivers zero-risk B2B metal trade for foundries, rolling mills and verified scrap aggregators.",
  },
  {
    q: "Which materials and steel hubs does LohaLink cover?",
    a: "LohaLink is a B2B metal scrap marketplace covering HMS 1, HMS 1 & 2 (80:20), shredded steel scrap, CI scrap, MS turning scrap, sponge iron (DRI), MS billets, pig iron, ingot and ferro alloys — across Durgapur, Kolkata, Jharsuguda, Raipur, Asansol, Mandi Gobindgarh, Jalna, Alang, Ghaziabad and other major Indian steel hubs.",
  },
];

export const ORGANIZATION_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "LohaLink",
  alternateName: "LohaLink — B2B Metal Scrap & Sponge Iron Marketplace",
  url: "https://lohalink.in",
  logo: "https://lohalink.in/favicon.ico",
  description:
    "India's verified B2B metal scrap marketplace — escrow for metal trade India, GST verified scrap dealers, verified sponge iron suppliers, MS billets and HMS 1 scrap.",
  sameAs: [
    "https://www.lohalink.in",
    "https://lohalink-trust-trade.lovable.app",
  ],
  areaServed: "IN",
};

export const LOCAL_BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://lohalink.in/#localbusiness",
  name: "LohaLink",
  url: "https://lohalink.in/about",
  image: "https://lohalink.in/favicon.ico",
  priceRange: "₹₹",
  telephone: "+91-00000-00000",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Howrah",
    addressRegion: "West Bengal",
    addressCountry: "IN",
  },
  areaServed: [
    "Durgapur",
    "Kolkata",
    "Jharsuguda",
    "Raipur",
    "Asansol",
    "Mandi Gobindgarh",
    "Jalna",
    "Alang",
    "Ghaziabad",
    "Giridih",
  ],
  description:
    "B2B metal scrap marketplace with escrow-protected payments, GSTIN auto-verification and AI scrap metal grading for foundries, rolling mills and verified scrap aggregators across India.",
};

export const FAQ_LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: ABOUT_FAQS.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
};
